import styled, { css } from 'styled-components'

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const SelectWrapper = styled.div<{
  $hasError: boolean
  $disabled?: boolean
}>`
  .react-select__control {
    min-height: 40px;
    border-width: 2px;
    border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#d9d9d9')};
    border-radius: 4px;
    box-shadow: none;

    &:hover {
      border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
    }
  }

  .react-select__control--is-focused {
    border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
    box-shadow: none;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      .react-select--is-disabled .react-select__control,
      .react-select__control--is-disabled {
        background-color: #f5f5f5;
        border-color: #d9d9d9;
        cursor: not-allowed;

        &:hover {
          border-color: #d9d9d9;
        }
      }

      .react-select--is-disabled .react-select__placeholder,
      .react-select--is-disabled .react-select__single-value,
      .react-select--is-disabled .react-select__input-container {
        color: rgba(0, 0, 0, 0.25);
      }

      .react-select--is-disabled .react-select__multi-value {
        background-color: rgba(0, 0, 0, 0.04);
        opacity: 1;
      }

      .react-select--is-disabled .react-select__multi-value__label {
        color: rgba(0, 0, 0, 0.25);
      }

      .react-select--is-disabled .react-select__multi-value__remove {
        color: rgba(0, 0, 0, 0.25);
        cursor: not-allowed;

        &:hover {
          background-color: transparent;
          color: rgba(0, 0, 0, 0.25);
        }
      }

      .react-select--is-disabled .react-select__dropdown-indicator {
        color: rgba(0, 0, 0, 0.25);
      }

      .react-select--is-disabled .react-select__indicator-separator {
        background-color: rgba(0, 0, 0, 0.06);
      }
    `}
`
